import React from "react"
import styled from "styled-components"
import { device } from "../../utils/breakpoints"
import { colors } from "../../utils/theme"

//images
import CardBack from "../../images/card-benefits.svg"
import { Col, Row } from "react-bootstrap"
import Item from "./Item"

const Card = styled.div`
  position: relative;
  z-index: 1;
  transform: translateY(0px);
  width: 100%;
  opacity: inherit !important;
  border-bottom: 8px solid ${colors.sColor};
  margin-bottom: 9rem;
  margin-top: 5rem;
  @media ${device.md} {
    transform: translateY(-70px);
    margin-top: 0;
  }
  & .benefits-title {
    text-align: center;
    z-index: -1;
    color: white;
    transform: translateY(-10px);
    font-size: 1em;
    & span {
      padding: 1.8rem 2em 2.5rem 2em;
      border: 4px solid ${colors.sColor};
      &::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 330%;
        transform: translateX(-50%);
        border-left: 30px solid transparent;
        border-right: 30px solid transparent;
        border-top: 30px solid ${colors.sColor};
        @media ${device.md} {
          width: 0;
          height: 0;
        }
      }
    }
  }
  & .benefits-content {
    position: relative;
    background: transparent;
    background-image: url(${CardBack});
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;
    height: auto;
    width: 100%;
    color: white;
    z-index: 1;
    box-shadow: 0 3px 40px rgb(115 0 230 / 31%);
    padding: 4rem 0 0 0;
    &-col {
      padding-bottom: 0 !important;
      padding-top: 0 !important;
      &:first-child {
        padding-top: 3.6rem !important;
        @media ${device.md} {
          padding-top: 0rem !important;
        }
      }
    }
    &::after {
      display: none;
    }
    @media ${device.md} {
      padding: 1rem 0 0 0;
    }
    @media ${device.md} {
      padding: 1rem 0 0 0;
      &::after {
        display: block;
        content: "";
        width: 2px;
        height: 60%;
        background: ${colors.pColor};
        top: 50%;
        left: 50%;
        transform: translate(-50%, -40%);
        position: absolute;
      }
    }
    &-date {
      position: absolute;
      left: 50%;
      top: 100%;
      text-align: center;
      background: ${colors.sColor};
      padding: 1em 2em;
      transform: translateX(-50%);
      & span.date {
        color: ${colors.pColor};
        text-transform: uppercase;
        font-size: 0.8em;
        font-family: "sketter";
        @media ${device.md} {
          font-size: 1.3em;
        }
      }
      & span.duration {
        position: absolute;
        width: 100%;
        top: 110%;
        left: 50%;
        transform: translateX(-50%);
        &::after {
          position: absolute;
          content: "";
          height: 2px;
          width: 20%;
          background: ${colors.sColor};
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          display: none;
          @media ${device.md} {
            display: block;
            font-size: 1.3em;
          }
        }
        &::before {
          position: absolute;
          content: "";
          height: 2px;
          width: 20%;
          background: ${colors.sColor};
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          display: none;
          @media ${device.md} {
            display: block;
            font-size: 1.3em;
          }
        }
      }
    }
    @media ${device.md} {
      padding: 6rem 2rem 0rem 2rem;
    }
  }
`

function CardBenefits() {
  return (
    <Card>
      <h3 className="benefits-title">
        <span>Al inscribirte tendrás</span>
      </h3>
      <div className="benefits-content">
        <Row>
          <Col md={6} className="p-5 benefits-content-col">
            <Item
              number="1"
              desc="<p>Acceso a el contenido donde aprenderas paso a paso el proceso para la creación de un personaje <i>CYBERPUNK</i> con <strong>ZBRUSH</strong><p>"
            />
            <Item number="2" desc="<p>Carpeta de <i>REFERENCIAS</i><p>" />
            <Item number="3" desc="<p>Acceso a <i>Discord</i><p>" />
          </Col>
          <Col md={6} className="p-5 benefits-content-col">
            <Item
              number="4"
              desc="<p><i>Acceso a interfaz y recursos</i> por el instructor <p>"
            />
            <Item number="5" desc="<p>Acceso a <i>FEEDBACK</i><p>" />
            <Item
              number="6"
              desc="<p>Acceso al contenido por un <i>año completo</i><p>"
            />
          </Col>
        </Row>
        <div className="benefits-content-date">
          <span
            style={{
              display: "block",
              textTransform: "uppercase",
              fontWeight: "700",
              color: "#545454",
            }}
          >
            {" "}
            Inicia:{" "}
          </span>
          <span className="date">19 de abril</span>
          <span className="duration">DURACIÓN: 1 MES</span>
        </div>
      </div>
    </Card>
  )
}

export default CardBenefits
